import { useState } from 'react';
import { lsGet, lsSet } from '../lib/storage';
import PWAInstallSheet from './PWAInstallSheet';

const HINT_DISMISSED_KEY = 'diwanPWAHintDismissed';
const JOSEFIN = "'Josefin Sans', sans-serif";

export default function PWAInstallHint() {
  const [sheetOpen, setSheetOpen]       = useState(false);
  const [hintDismissed, setHintDismissed] = useState(
    () => lsGet(HINT_DISMISSED_KEY) === 'true'
  );

  // Never show if already installed
  if (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  ) return null;

  // Never show if permanently dismissed from the hint itself
  if (hintDismissed) return null;

  function dismissHint(e) {
    e.stopPropagation();
    lsSet(HINT_DISMISSED_KEY, 'true');
    setHintDismissed(true);
  }

  return (
    <>
      {!sheetOpen && <div style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.35rem',
        border: '1px solid var(--border)',
        borderRadius: 4,
        padding: '0.45rem 0.75rem 0.45rem 0.6rem',
        cursor: 'pointer',
      }}>
        {/* Main tap area opens sheet */}
        <button
          onClick={() => setSheetOpen(true)}
          style={{
            background: 'transparent',
            border: 'none',
            padding: 0,
            display: 'flex',
            alignItems: 'center',
            gap: '0.35rem',
            cursor: 'pointer',
          }}
          aria-label="Add Al-Diwan to your home screen"
        >
          <span style={{
            fontSize: '0.75rem',
            color: 'var(--em)',
            lineHeight: 1,
          }}>
            ⊕
          </span>
          <span style={{
            fontFamily: JOSEFIN,
            fontSize: '0.55rem',
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
            color: 'var(--text3)',
          }}>
            Add to home screen
          </span>
        </button>

        {/* Permanent dismiss — small × after the label */}
        <button
          onClick={dismissHint}
          style={{
            background: 'transparent',
            border: 'none',
            padding: '0 0 0 0.2rem',
            cursor: 'pointer',
            color: 'var(--text3)',
            fontSize: '0.65rem',
            lineHeight: 1,
            opacity: 0.6,
          }}
          aria-label="Don't show this again"
          title="Don't show this again"
        >
          ✕
        </button>
      </div>}

      {sheetOpen && (
        <PWAInstallSheet
          forceOpen={true}
          onClose={() => setSheetOpen(false)}
        />
      )}
    </>
  );
}
